import { callBackendApi } from "../../components/service/axios";
import {Scope} from "../information-assets/models/system-resources";

export type UserGroupType = {
  id: string;
  columnName: string;
  name: string;
  tabName: string;
  titleName: string;
  uniqueName: string;
}
export const getUserGroupTypes = async (): Promise<UserGroupType[]> => {
  return await callBackendApi("get", "/bff/user-groups/types");
};

export type UserGroupScope = {
  id: String,
  userGroupId: String,
  userGroupType: String,
  scope: Scope
}

export const getAllUserGroupScope = async (): Promise<UserGroupScope[]> => {
  return await callBackendApi("get", "/bff/user-groups/scope")
}
